module.exports = __webpack_public_path__ + "static/media/auction.4db60fbd.png";